import DriverMarker from '@loggi/ui/components/driver-marker';
import Map from '@loggi/ui/components/map';
import MapMarker from '@loggi/ui/components/map-marker';
import colors from '@loggi/ui/components/utils/colors';
import icons from '@loggi/ui/components/utils/icons';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './map-background.styles.scss';

function MapBackground(props) {
  const { lat, lng, mapMarkerColor, mapMarkerIcon, driverPosition } = props;
  const zoomDefault = 17;
  const defaultMapOptions = {
    disableDefaultUI: true,
    gestureHandling: 'greedy'
  };
  const hasDriver = Boolean(driverPosition);
  const defaultBounds = hasDriver && { width: 300, height: 150 };

  return (
    <div className="map-container">
      <Map
        options={defaultMapOptions}
        initialCenter={{ lat, lng }}
        initialZoom={zoomDefault}
        fitBounds={hasDriver}
        bounds={defaultBounds}
        channel="tracker"
        initialShouldRenderMap
      >
        <MapMarker
          className={styles.iconSize}
          color={mapMarkerColor}
          icon={mapMarkerIcon}
          lat={lat}
          lng={lng}
        />
        {driverPosition && <DriverMarker {...driverPosition} />}
      </Map>
    </div>
  );
}

MapBackground.displayName = 'MapBackground';
MapBackground.propTypes = {
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired,
  mapMarkerColor: PropTypes.string,
  mapMarkerIcon: PropTypes.string,
  driverPosition: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number
  })
};

MapBackground.defaultProps = {
  mapMarkerColor: colors.type.ACTIVE,
  mapMarkerIcon: icons.type.HOME,
  driverPosition: null
};

export default MapBackground;
